import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  FetchRequestHandler,
  FetchRequestHandlerLoginTest,
} from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { v4 as uuidV4 } from "uuid";

export const fetchProviderAuthenticateWhileLogin = createAsyncThunk(
  "fetchProviderAuthenticateWhileLogin",
  async (data) => {
    const result = await FetchRequestHandlerLoginTest(
      "post",
      `${baseUrl}api/security/authenticate`,
      data
    );

    return result;
  }
);

export const fetchLoginUserDetails = createAsyncThunk(
  "fetchLoginUserDetails",
  async (userId) => {
    const result = await FetchRequestHandlerLoginTest(
      "get",
      `${baseUrl}api/users/${userId}`
    );
    return result;
  }
);

export const fetchUpdatePhoneNumber = createAsyncThunk(
  "fetchUpdatePhoneNumber",
  async (data) => {
    // const authKey = localStorage.getItem("auth-key");
    const config = {
      headers: {
        // "X-DeviceFP": "d485dbc29097bda4b5bc5b8325f5af46f2b036be678",
        // Authorization: `Bearer ${authKey}`,
        // "Content-Type": "application/json",
        "X-Request-Id": uuidV4(),
      },
    };

    try {
      const response = await axios({
        method: "post",
        url: `${baseUrl}api/security/add-2-factor-phone-number`,
        data,
        ...config,
      });
      return { success: true, data: response.data, status: response.status };
    } catch (error) {
      return {
        success: false,
        data: error.response?.data || null,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
);

export const fetchUpdatePassword = createAsyncThunk(
  "fetchUpdatePassword",
  async ({ userId, data }) => {
    const result = await FetchRequestHandlerLoginTest(
      "put",
      `${baseUrl}api/users/${userId}`,
      data
    );
    console.log({ result });
    return result;
  }
);

export const fetchProviderPinVerification = createAsyncThunk(
  "fetchProviderPinVerification",
  async (data) => {
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/users/verify-2-factor-verification-code`,
      data
    );

    return result;
  }
);

export const fetchForgotPassword = createAsyncThunk(
  "fetchForgotPassword",
  async (data) => {
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/users/reset-password`,
      data
    );

    return result;
  }
);

export const fetchProviderResendVerification = createAsyncThunk(
  "fetchProviderResendVerification",
  async (data) => {
    // const result = await FetchRequestHandlerLoginTest(
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/users/resend-2-factor-verification-code`,
      data
    );

    return result;
  }
);

export const fetchUserByToken = createAsyncThunk(
  "fetchUserByToken",
  async (token) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/users/user-by-token?token=${token}`
    );
    console.log({ result });

    return result;
  }
);

export const fetchChangePassword = createAsyncThunk(
  "fetchChangePassword",
  async (data) => {
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/users/change-password`,
      data
    );
    return result;
  }
);
